import type { FairIconName } from '@/ui/tokens/icons.data'

const mainIconModules = import.meta.glob('../../icons/main/*.svg', {
  query: '?raw',
  import: 'default',
  eager: true,
}) as Record<string, string>

function slugFromPath(path: string): string {
  const match = path.match(/\/([^/]+)\.svg$/)
  return match?.[1] ?? path
}

const MAIN_ICON_SVG: Record<string, string> = Object.fromEntries(
  Object.entries(mainIconModules).map(([path, svg]) => [slugFromPath(path), svg]),
)

export function getMainIconSvg(name: FairIconName): string {
  return MAIN_ICON_SVG[name] ?? ''
}
